import { render, staticRenderFns } from "./FormTags.vue?vue&type=template&id=04582b32&"
import script from "./FormTags.vue?vue&type=script&lang=js&"
export * from "./FormTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports